module.exports = __webpack_public_path__ + "img/13.0fc0d857.jpg";